import { message, notification } from 'antd';
import axios from 'axios';
import { stringifyQuery } from '@/common/utils/query';

let unauthorizedHandler;
export const setUnauthorizedHandler = (handler) => {
  unauthorizedHandler = handler;
};

const requestBaseConfig = {
  baseURL: process.env.VITE_API_BASE || '',
  timeout: 60 * 60 * 1000,
  withCredentials: true,
  paramsSerializer: {
    serialize: stringifyQuery,
  },
  headers: {
    'Content-Type': 'application/json',
  },
};

const defaultClient = axios.create(requestBaseConfig);
const localHandlingClient = axios.create(requestBaseConfig);

defaultClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const payload = error.response?.data;
    if (status === 401) {
      await unauthorizedHandler?.();
    }
    if (payload?.showType === 3) {
      notification.error({
        message: payload.errorCode ?? '请求失败',
        description: payload.errorMessage ?? payload?.message ?? '请稍后重试',
      });
    } else {
      message.error(payload?.errorMessage ?? payload?.message ?? '网络请求失败，请稍后重试');
    }
    return Promise.reject(error);
  },
);

const requestWithClient = async (client, url, config) => {
  const response = await client.request({
    url,
    ...config,
  });
  return response.data;
};

export const request = async (url, config = {}) => requestWithClient(defaultClient, url, config);

export const requestWithLocalErrorHandling = async (url, config = {}) =>
  requestWithClient(localHandlingClient, url, config);
